import type { GuideStep } from '../types';

export const CANVAS_BASICS_STEPS: GuideStep[] = [
  {
    id: 'canvas-1',
    page: 'index',
    section: 'canvas-basics',
    target: 'canvas',
    title: { sv: 'Panorera', en: 'Pan the canvas' },
    body: {
      sv: 'Håll nere mellanknappen eller mellanslag + vänsterklick och dra för att panorera. På mobil drar du med två fingrar.',
      en: 'Hold middle-click or Space + left-click and drag to pan. On mobile, drag with two fingers.',
    },
    placement: 'auto',
    order: 1,
  },
  {
    id: 'canvas-2',
    page: 'index',
    section: 'canvas-basics',
    target: 'canvas',
    title: { sv: 'Zooma', en: 'Zoom' },
    body: {
      sv: 'Scrolla musen eller nyp ihop fingrarna för att zooma. Ctrl + 0 återställer zoom.',
      en: 'Scroll or pinch to zoom. Ctrl + 0 resets zoom.',
    },
    placement: 'auto',
    order: 2,
  },
  {
    id: 'canvas-3',
    page: 'index',
    section: 'canvas-basics',
    target: 'minimap',
    mobileTarget: null,
    title: { sv: 'Minikartan', en: 'The minimap' },
    body: {
      sv: 'Se hela workflowet ovanifrån. Klicka var du vill — canvasen hoppar dit.',
      en: 'See the whole workflow from above. Click anywhere and the canvas jumps there.',
    },
    placement: 'top',
    order: 3,
  },
  {
    id: 'canvas-4',
    page: 'index',
    section: 'canvas-basics',
    target: 'canvas',
    title: { sv: 'Rutnätet', en: 'The grid' },
    body: {
      sv: 'Block snappar automatiskt till ett 20 px-rutnät. Det håller layouten prydlig även när du ritar snabbt.',
      en: 'Blocks snap to a 20 px grid, keeping your layout tidy even when you draw fast.',
    },
    placement: 'auto',
    order: 4,
  },
];
